(function () {
  /* ==========================================================================
     CODICE UNICO CARRELLO — Femmabelle
     File del tema: assets/rlv-carrello.js (caricato da layout/theme.liquid).
     Le impostazioni da modificare sono qui sotto, nel blocco IMPOSTAZIONI.
     ========================================================================== */

  /* ========================= IMPOSTAZIONI (modifica qui) ========================= */
  var PAGINA_PRODOTTO = '/products/femmabelle';    /* pagina prodotto a cui tornare */

  /* Cosa succede con il carrello vuoto:
     'ovunque'  = quasi ogni pagina del sito riporta al prodotto
     'carrello' = solo quando il cliente svuota o apre il carrello vuoto
     'no'       = nessun reindirizzamento */
  var CARRELLO_VUOTO = 'ovunque';

  /* Pagine che restano raggiungibili anche con il carrello vuoto (basta che l'indirizzo le contenga) */
  var PAGINE_ESCLUSE = ['/policies', '/pages/', '/account', '/checkouts', '/orders', '/apps/'];

  /* Se il carrello laterale non si apre: 'messaggio' = resta sulla pagina;  'pagina' = va su /cart */
  var SE_NON_SI_APRE = 'messaggio';

  /* Barra fissa "Aggiungi al carrello" (solo sulla pagina prodotto). Metti mostra: false per non usarla. */
  var BARRA = {
    mostra: true,
    nome: 'FemmaBelle™ Dispositivo per il comfort nei giorni del ciclo',
    valutazione: '4.7 / 5',
    prezzo: '€ 39,90',
    prezzoBarrato: '€ 59,90',
    badgeMobile: 'FemmaBelle™',
    testoPulsante: 'AGGIUNGI AL CARRELLO',
    colore: '#6E1F2F',         /* bordeaux: nome, prezzo, pulsante */
    sfondo: '#fdf1ee',         /* sfondo della barra */
    bordo: '#e8d5cd'           /* linea sopra la barra */
  };
  /* =============================================================================== */

  /* Non intervenire nell'editor (dentro una cornice) né nell'editor del tema */
  if (window.top !== window.self) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var path = window.location.pathname;
  var suProdotto = path.indexOf(PAGINA_PRODOTTO) !== -1;
  var DEBUG = /[?&]rlvdebug=1/.test(window.location.search);
  var registro = [];
  var inCorso = false;
  var consentiCarrello = false;   /* true solo quando siamo NOI a mandare volutamente su /cart */

  /* ---------- 1) Pagina /cart: porta alla pagina prodotto (dove si apre il carrello laterale) ---------- */
  if (/\/cart\/?$/.test(path)) {
    window.location.replace(PAGINA_PRODOTTO + '?rlvcart=1');
    return;
  }

  /* ---------- Funzioni di servizio ---------- */
  function nota(t) { registro.push(t); }
  function attendi(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  function quandoPronto(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function visibile(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }
  function descrivi(el) {
    var t = (el.innerText || el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 30);
    return el.tagName.toLowerCase() + (el.id ? '#' + el.id : '') +
      (el.className && typeof el.className === 'string' ? '.' + el.className.trim().split(/\s+/).slice(0, 3).join('.') : '') +
      (el.getAttribute('href') ? ' [href=' + el.getAttribute('href') + ']' : '') + (t ? ' "' + t + '"' : '');
  }

  /* ---------- 2) Apertura del carrello laterale ---------- */

  /* Il carrello laterale è aperto? (pannello fisso, alto e visibile, che parla di "carrello") */
  function carrelloAperto() {
    var els = document.querySelectorAll('aside, dialog, [role="dialog"], [class*="drawer" i], [id*="drawer" i], [class*="cart" i], [id*="cart" i], [class*="sidebar" i], [class*="panel" i]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest('.rlv-sticky-bar') || el.id === 'rlv-avviso' || el.id === 'rlv-debug') continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 200 || r.height < window.innerHeight * 0.6) continue;
      var larghezzaVisibile = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
      if (larghezzaVisibile < 200) continue;
      var fisso = false, p = el;
      while (p && p !== document.body) {
        if (window.getComputedStyle(p).position === 'fixed') { fisso = true; break; }
        p = p.parentElement;
      }
      if (!fisso) continue;
      if (/carrello|cart/i.test(el.innerText || '')) { nota('carrello aperto rilevato: ' + descrivi(el)); return true; }
    }
    return false;
  }

  /* Trova le icone/pulsanti del carrello, dal più affidabile al meno affidabile */
  function trovaCandidati() {
    var gruppi = [
      '#cart-icon-btn, [data-cart-toggle], [data-cart-drawer-toggle], [data-drawer-toggle*="cart" i], [data-action*="cart" i], [aria-controls*="cart" i], #cart-icon-bubble',
      'a[href$="/cart"], a[href*="/cart?"]',
      '[class*="cart-icon" i], [class*="cart-toggle" i], [class*="cart-link" i], [class*="cart-button" i], [class*="header__cart" i], [class*="cart-count" i], [class*="cart-bubble" i]'
    ];
    var intestazioni = document.querySelectorAll('header, [role="banner"], nav, [class*="header" i], [id*="header" i], [class*="navbar" i], [class*="topbar" i]');
    var trovati = [];
    function considera(el) {
      if (!el || trovati.indexOf(el) !== -1 || !visibile(el)) return;
      if (el.closest('.rlv-sticky-bar') || el.closest('form[action*="/cart/add"]')) return;
      if (el.matches('[type="submit"], [name="add"]')) return;
      if (/aggiungi|add to cart|acquista|checkout/i.test((el.innerText || '') + ' ' + (el.getAttribute('aria-label') || ''))) return;
      trovati.push(el);
    }
    gruppi.forEach(function (sel) {
      Array.prototype.forEach.call(intestazioni, function (h) {
        Array.prototype.forEach.call(h.querySelectorAll(sel), considera);
        if (h.matches(sel)) considera(h);
      });
    });
    if (!trovati.length) {
      Array.prototype.forEach.call(document.querySelectorAll(gruppi[1] + ', [aria-controls*="cart" i]'), considera);
    }
    return trovati.slice(0, 8);
  }

  function evento(tipo) {
    try {
      if (tipo.indexOf('pointer') === 0 && window.PointerEvent) {
        return new PointerEvent(tipo, { bubbles: true, cancelable: true, view: window });
      }
      return new MouseEvent(tipo, { bubbles: true, cancelable: true, view: window });
    } catch (e) { return null; }
  }

  /* Simula il tocco. Restituisce true se il sito ha "preso in carico" il clic.
     Se è un link che il sito NON intercetta, blocca la navigazione e restituisce false. */
  function clicca(el) {
    var eLink = el.tagName === 'A' && !!el.getAttribute('href');
    var preso = !eLink;
    function controlla(e) {
      if (el === e.target || el.contains(e.target)) {
        if (e.defaultPrevented) preso = true;
        else if (eLink) e.preventDefault();
      }
    }
    window.addEventListener('click', controlla, false);
    try {
      ['pointerdown', 'mousedown', 'pointerup', 'mouseup'].forEach(function (t) {
        var ev = evento(t); if (ev) el.dispatchEvent(ev);
      });
      el.click();
    } catch (err) {}
    window.removeEventListener('click', controlla, false);
    return preso;
  }

  function apriCarrello() {
    return attendi(700).then(function () {
      if (carrelloAperto()) { nota('il sito ha aperto il carrello da solo'); return true; }
      var candidati = trovaCandidati();
      nota('candidati trovati: ' + (candidati.length ? candidati.map(descrivi).join(' | ') : 'nessuno'));
      var i = 0;
      function prossimo() {
        if (i >= candidati.length) return Promise.resolve(false);
        var el = candidati[i++];
        var preso = clicca(el);
        nota('clic su ' + descrivi(el) + ' -> ' + (preso ? 'preso in carico' : 'ignorato dal sito'));
        return attendi(600).then(function () {
          if (carrelloAperto()) return true;
          if (preso) { nota('clic gestito dal sito (carrello non riconosciuto, mi fermo)'); return true; }
          return prossimo();
        });
      }
      return prossimo();
    });
  }

  function mostraAvviso() {
    if (document.getElementById('rlv-avviso')) return;
    var d = document.createElement('div');
    d.id = 'rlv-avviso';
    d.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:1000;background:' + BARRA.colore +
      ';color:#F3E3E5;padding:12px 20px;border-radius:999px;font:700 14px Belleza,system-ui,sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.25);white-space:nowrap;';
    d.innerHTML = 'Prodotto aggiunto al carrello ✓ &nbsp;<a href="/cart" style="color:#F3E3E5;text-decoration:underline;">Vedi carrello</a>';
    document.body.appendChild(d);
    setTimeout(function () { if (d.parentNode) d.parentNode.removeChild(d); }, 7000);
  }

  function mostraResoconto() {
    var d = document.createElement('pre');
    d.id = 'rlv-debug';
    d.style.cssText = 'position:fixed;top:10px;left:10px;right:10px;max-height:60vh;overflow:auto;z-index:100000;background:#111;color:#0f0;' +
      'padding:12px;font:12px/1.4 monospace;white-space:pre-wrap;border-radius:8px;';
    d.textContent = 'RESOCONTO (copia e invia tutto questo testo)\n\n' + registro.join('\n');
    document.body.appendChild(d);
  }

  /* ---------- 3) Aggiungi al carrello + apri la tendina (usata dal pulsante della barra) ---------- */
  function aggiungiAlCarrello() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) { nota('ATTENZIONE: nessun modulo prodotto trovato sulla pagina'); return Promise.resolve(); }
    return fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      nota('aggiunta al carrello: risposta ' + r.status);
      return r.json();
    });
  }

  function aggiungiEApri(btn) {
    if (inCorso) return;
    inCorso = true;
    registro = [];
    if (btn) btn.disabled = true;
    function fine() {
      inCorso = false;
      if (btn) btn.disabled = false;
      if (DEBUG) mostraResoconto();
    }
    function apri() {
      apriCarrello().then(function (aperto) {
        if (!aperto) {
          nota('carrello laterale NON aperto');
          if (SE_NON_SI_APRE === 'pagina') { consentiCarrello = true; window.location.href = '/cart'; return; }
          mostraAvviso();
        }
        fine();
      }, function (e) { nota('errore: ' + e); fine(); });
    }
    aggiungiAlCarrello().then(apri, function (e) { nota('errore nell\'aggiunta: ' + e); apri(); });
  }

  /* Compatibilità: se sulla pagina è rimasto un vecchio pulsante che chiama rlvAggiungiEApri() */
  if (typeof window.rlvAggiungiEApri !== 'function') window.rlvAggiungiEApri = aggiungiEApri;

  /* ---------- 3b) Il sito (pulsante "ACQUISTA ORA", app dei bundle...) prova a portare su /cart
     dopo l'aggiunta: lo impediamo e lasciamo aperto il carrello laterale ---------- */
  var bloccoInCorso = false;
  function dopoBloccoNavigazione() {
    if (bloccoInCorso) return;
    bloccoInCorso = true;
    nota('navigazione verso /cart bloccata: resto sulla pagina');
    attendi(700).then(function () {
      if (carrelloAperto()) { nota('carrello laterale già aperto: non tocco nulla'); return true; }
      return apriCarrello();
    }).then(function (aperto) {
      if (!aperto) { nota('carrello laterale non aperto dopo il blocco'); mostraAvviso(); }
    }).catch(function () {}).then(function () {
      bloccoInCorso = false;
      if (DEBUG) mostraResoconto();
    });
  }
  if (window.navigation && typeof window.navigation.addEventListener === 'function') {
    window.navigation.addEventListener('navigate', function (e) {
      try {
        if (consentiCarrello || !e.cancelable || e.userInitiated || e.formData) return;
        if (e.navigationType === 'traverse' || e.navigationType === 'reload') return;
        var dest = new URL(e.destination.url);
        if (dest.origin !== window.location.origin || !/\/cart\/?$/.test(dest.pathname)) return;
        e.preventDefault();
        dopoBloccoNavigazione();
      } catch (err) {}
    });
  }

  /* ---------- 4) Arrivo dalla pagina /cart (?rlvcart=1): apre da solo il carrello laterale ---------- */
  if (/[?&]rlvcart=1/.test(window.location.search)) {
    var avviato = false;
    var ripulisciIndirizzo = function () {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('rlvcart');
        window.history.replaceState(null, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    };
    var tenta = function (n) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c.item_count) { nota('carrello vuoto: non apro nulla'); ripulisciIndirizzo(); return; }
          return apriCarrello().then(function (aperto) {
            if (!aperto && n < 8) return attendi(1500).then(function () { return tenta(n + 1); });
            ripulisciIndirizzo();
            if (DEBUG) mostraResoconto();
          });
        })
        .catch(ripulisciIndirizzo);
    };
    var parti = function () {
      if (avviato) return;
      avviato = true;
      attendi(600).then(function () { tenta(0); });
    };
    if (document.readyState === 'complete') parti();
    else window.addEventListener('load', parti);
  }

  /* ---------- 5) Carrello vuoto: torna alla pagina prodotto ---------- */
  if (CARRELLO_VUOTO !== 'no') {
    var vaiAlProdotto = function () { if (!suProdotto) window.location.href = PAGINA_PRODOTTO; };
    var controllaCarrelloVuoto = function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c.item_count === 0) vaiAlProdotto(); })
        .catch(function () {});
    };
    var RE_MODIFICA = /\/cart\/(change|update|clear)/;

    /* A) quando il cliente toglie l'ultimo articolo (carrello laterale o altre pagine) */
    var _fetch = window.fetch;
    window.fetch = function () {
      var a = arguments;
      var url = typeof a[0] === 'string' ? a[0] : ((a[0] && a[0].url) || '');
      return _fetch.apply(this, a).then(function (res) {
        if (RE_MODIFICA.test(url)) setTimeout(controllaCarrelloVuoto, 300);
        return res;
      });
    };
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      var u = url || '';
      this.addEventListener('load', function () {
        if (RE_MODIFICA.test(u)) setTimeout(controllaCarrelloVuoto, 300);
      });
      return _open.apply(this, arguments);
    };

    /* B) clic sull'icona del carrello: se è vuoto, torna al prodotto */
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest(
        'a[href$="/cart"], a[href*="/cart?"], [aria-controls*="cart" i], [class*="cart-icon" i], [class*="cart-toggle" i], [class*="cart-link" i], [id*="cart-icon" i]'
      );
      if (el) setTimeout(controllaCarrelloVuoto, 250);
    }, true);

    /* C) modalità 'ovunque': controllo all'apertura di ogni pagina non esclusa */
    if (CARRELLO_VUOTO === 'ovunque') {
      var esclusa = PAGINE_ESCLUSE.some(function (p) { return path.indexOf(p) !== -1; });
      if (!esclusa && !suProdotto) {
        controllaCarrelloVuoto();
        window.addEventListener('pageshow', function (ev) { if (ev.persisted) controllaCarrelloVuoto(); });
      }
    }
  }

  /* ---------- 6) Barra fissa "Aggiungi al carrello" (solo pagina prodotto) ---------- */
  if (BARRA.mostra && suProdotto) {
    quandoPronto(function () {
      /* toglie eventuali vecchie barre (per esempio quella inserita da PageFly): resta solo questa */
      Array.prototype.forEach.call(document.querySelectorAll('.rlv-sticky-bar'), function (vecchia) {
        if (!vecchia.hasAttribute('data-rlv') && vecchia.parentNode) vecchia.parentNode.removeChild(vecchia);
      });
      if (document.querySelector('.rlv-sticky-bar[data-rlv]')) return;

      var stile = document.createElement('style');
      stile.textContent =
        "@import url('https://fonts.googleapis.com/css2?family=Belleza&display=swap');\n" +
        ".rlv-sticky-bar{position:fixed;left:0;right:0;bottom:0;z-index:999;background:" + BARRA.sfondo + ";border-top:1px solid " + BARRA.bordo + ";box-shadow:0 -4px 16px rgba(0,0,0,0.08);font-family:'Belleza',-apple-system,BlinkMacSystemFont,'Helvetica Neue',sans-serif;}\n" +
        ".rlv-sticky-bar *{box-sizing:border-box;}\n" +
        ".rlv-sticky-inner{max-width:1200px;margin:0 auto;padding:14px 24px;align-items:center;justify-content:space-between;gap:20px;}\n" +
        ".rlv-sticky-desktop{display:flex;}\n" +
        ".rlv-sticky-mobile{display:none;}\n" +
        ".rlv-sticky-info{display:flex;flex-direction:column;gap:4px;min-width:0;}\n" +
        ".rlv-sticky-name{font-size:16px;font-weight:700;color:" + BARRA.colore + ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}\n" +
        ".rlv-sticky-rating{font-size:13px;color:" + BARRA.colore + ";display:flex;align-items:center;gap:6px;}\n" +
        ".rlv-sticky-rating-num{color:#9C5A5D;font-size:12px;}\n" +
        ".rlv-sticky-action{display:flex;align-items:center;gap:20px;flex:0 0 auto;}\n" +
        ".rlv-sticky-price-block{display:flex;flex-direction:column;align-items:flex-end;gap:2px;}\n" +
        ".rlv-sticky-badge{font-size:13px;font-weight:700;color:" + BARRA.colore + ";white-space:nowrap;}\n" +
        ".rlv-sticky-price-row{display:flex;align-items:baseline;gap:8px;}\n" +
        ".rlv-sticky-price{font-size:22px;font-weight:700;color:" + BARRA.colore + ";white-space:nowrap;}\n" +
        ".rlv-sticky-compare-price{font-size:15px;font-weight:400;color:#9a9a9a;text-decoration:line-through;text-decoration-thickness:1px;white-space:nowrap;}\n" +
        ".rlv-sticky-btn{background:" + BARRA.colore + ";color:#ffffff;border:none;border-radius:999px;padding:14px 30px;font-size:13px;font-weight:700;letter-spacing:0.03em;cursor:pointer;white-space:nowrap;transition:background-color 0.2s ease,opacity 0.2s ease;font-family:'Belleza',-apple-system,BlinkMacSystemFont,'Helvetica Neue',sans-serif;}\n" +
        ".rlv-sticky-btn:disabled{opacity:0.7;cursor:wait;}\n" +
        "@media (max-width:720px){\n" +
        ".rlv-sticky-desktop{display:none;}\n" +
        ".rlv-sticky-mobile{display:flex;padding:12px 16px;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-price-block{align-items:flex-start;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-badge{font-size:12px;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-price{font-size:19px;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-compare-price{font-size:13px;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-btn{padding:12px 22px;font-size:12px;}\n" +
        "}\n" +
        "@media (max-width:380px){\n" +
        ".rlv-sticky-mobile .rlv-sticky-badge{font-size:11px;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-compare-price{font-size:11px;}\n" +
        ".rlv-sticky-mobile .rlv-sticky-btn{padding:11px 18px;font-size:11px;}\n" +
        "}\n";
      document.head.appendChild(stile);

      var barra = document.createElement('div');
      barra.className = 'rlv-sticky-bar';
      barra.setAttribute('data-rlv', '1');
      barra.innerHTML =
        '<div class="rlv-sticky-inner rlv-sticky-desktop">' +
          '<div class="rlv-sticky-info">' +
            '<span class="rlv-sticky-name"></span>' +
            '<span class="rlv-sticky-rating">★★★★★ <span class="rlv-sticky-rating-num"></span></span>' +
          '</div>' +
          '<div class="rlv-sticky-action">' +
            '<div class="rlv-sticky-price-block"><span class="rlv-sticky-badge"></span>' +
              '<span class="rlv-sticky-price-row"><span class="rlv-sticky-price"></span><span class="rlv-sticky-compare-price"></span></span>' +
            '</div>' +
            '<button type="button" class="rlv-sticky-btn"></button>' +
          '</div>' +
        '</div>' +
        '<div class="rlv-sticky-inner rlv-sticky-mobile">' +
          '<div class="rlv-sticky-price-block"><span class="rlv-sticky-badge rlv-sticky-badge-mobile"></span>' +
            '<span class="rlv-sticky-price-row"><span class="rlv-sticky-price"></span><span class="rlv-sticky-compare-price"></span></span>' +
          '</div>' +
          '<button type="button" class="rlv-sticky-btn"></button>' +
        '</div>';

      /* i testi vengono inseriti come testo semplice (nessun rischio di codice indesiderato) */
      function testo(sel, valore) {
        Array.prototype.forEach.call(barra.querySelectorAll(sel), function (el) { el.textContent = valore; });
      }
      testo('.rlv-sticky-name', BARRA.nome);
      testo('.rlv-sticky-rating-num', BARRA.valutazione);
      testo('.rlv-sticky-price', BARRA.prezzo);
      testo('.rlv-sticky-compare-price', BARRA.prezzoBarrato);
      testo('.rlv-sticky-badge-mobile', BARRA.badgeMobile);
      testo('.rlv-sticky-btn', BARRA.testoPulsante);

      Array.prototype.forEach.call(barra.querySelectorAll('.rlv-sticky-btn'), function (b) {
        b.addEventListener('click', function () { aggiungiEApri(b); });
      });
      document.body.appendChild(barra);
    });
  }
})();